import './components/page-loader.js';
import './_drawer.js';
import './_tab.js';
import './_dialog.js';
import './components/faq.js';
import './components/typewriter.js';
import './components/fade-in.js';